import { render, staticRenderFns } from "./BaseInfoColumn.vue?vue&type=template&id=0b4836e8&scoped=true&"
import script from "./BaseInfoColumn.vue?vue&type=script&lang=js&"
export * from "./BaseInfoColumn.vue?vue&type=script&lang=js&"
import style0 from "./BaseInfoColumn.vue?vue&type=style&index=0&id=0b4836e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4836e8",
  null
  
)

export default component.exports